import { TrialInfoStatus } from '../../../Common/enums';
import { Switch } from '../../../components';
import {
    BulletList,
    Button,
    Card,
    CardType,
    LabelBody,
    LabelBodyHeadline,
    LabelHeader4,
} from '../components';
import { continueOnboardingFlow } from '../nativeAPI';

type Props = {
    type: TrialInfoStatus;
};
export function TrialInfoCard({ type }: Props) {
    return (
        <div
            style={{
                background:
                    'linear-gradient(180deg, rgba(255, 255, 255, 0) 0.11%, #FFFFFF 240px)',
                paddingTop: '240px',
                inset: '-1px',
                bottom: 'initial',
                position: 'absolute',
                paddingBottom: '20px',
            }}
        >
            <Switch
                value={type}
                cases={{
                    AwaitingRequestProcessing: (
                        <Card type={CardType.DarkBlue}>
                            <LabelHeader4 color="text-white">
                                Afventer psykologens vurdering
                            </LabelHeader4>
                            <LabelBody color="text-white" className="my-10">
                                Du bruger stadig den gratis version af appen,
                                fordi psykologen endnu ikke har gennemgået dine
                                spørgeskemasvar.
                            </LabelBody>
                            <LabelBody color="text-white">
                                Når dine svar er blevet gennemgået, vil du
                                automatisk få adgang til det forløb, du har
                                købt.
                            </LabelBody>
                        </Card>
                    ),
                    FillOutRequest: (
                        <Card type={CardType.DarkBlue}>
                            <LabelHeader4 color="text-white">
                                Vi mangler dit svar på spørgeskemaet
                            </LabelHeader4>
                            <LabelBody color="text-white" className="my-10">
                                Du bruger stadig den gratis version af appen,
                                fordi du mangler at udfylde det spørgeskema, vi
                                bruger til at vurdere, om SundtSind er den rette
                                hjælp for dig.
                            </LabelBody>
                            <LabelBody color="text-white">
                                Når dine spørgeskemasvar er blevet gennemgået,
                                vil du automatisk få adgang til det forløb, du
                                har købt.
                            </LabelBody>
                            <Button
                                variant="tertiary"
                                className="mt-20"
                                onClick={continueOnboardingFlow}
                            >
                                Gå til spørgeskema
                            </Button>
                        </Card>
                    ),
                    PaymentNeeded: (
                        <Card type={CardType.DarkRed}>
                            <LabelHeader4 color="text-white">
                                Få mere ro og overskud
                            </LabelHeader4>
                            <LabelBody
                                color="text-white"
                                className="mb-20 mt-10"
                            >
                                Du er allerede kommet så langt i at gøre noget
                                godt for dig selv.
                            </LabelBody>
                            <LabelBodyHeadline color="text-white">
                                Køb det fulde forløb med bl.a.
                            </LabelBodyHeadline>
                            <LabelBody
                                color="text-white"
                                className="mb-20 mt-10"
                            >
                                <BulletList
                                    items={[
                                        'Psykologsamtaler',
                                        'Guidede øvelser',
                                        'Redskaber til at arbejde videre med dig selv',
                                    ]}
                                />
                            </LabelBody>
                            <Button
                                variant="primary"
                                onClick={continueOnboardingFlow}
                            >
                                Start dit forløb i dag
                            </Button>
                        </Card>
                    ),
                }}
            />
        </div>
    );
}
